<div class="row">
  <div class="col-1">
    <app-back-button></app-back-button>
  </div>
  <div class="col">
    <h2 class="h2-responsive text-center">{{questionSet.title}}</h2>
  </div>
</div>
<div class="row">
  <mdb-tabset #staticTabs [buttonClass]="'col nav-tabs tabs-3 primary-color p-1'" [contentClass]="'card'"
    class="col-12">
    <mdb-tab heading="General" [customClass]="'order-1'">
      <app-question-set-core-form [questionSet]="questionSet"></app-question-set-core-form>
      <input type="button" (click)="save()" class="btn btn-primary" value="Save" />
    </mdb-tab>
    <mdb-tab heading="Labels" [customClass]="'order-2'" *ngIf="showQuestionLabelsForType(questionSet.display_type)"
      class="labelsContainer">
      <a [routerLink]="['label','new']" type="button" class="btn btn-primary">New Label</a>
      <p class="alert alert-info" *ngIf="!questionSet.labels.length">There are no labels.</p>
      <table class="table table-striped" *ngIf="questionSet.labels.length">
        <thead class="primary-color text-white">
          <tr>
            <th *ngFor="let name of ['Label', 'Answer Value', 'Actions']">{{name}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let label of questionSet.labels;let index = index;let first = first;let last=last;">
            <td class="50">{{label.label}}</td>
            <td>{{questionSet.answer_start_value + index}}</td>
            <td class="25">
              <button (click)="moveUpLabel(label)" [disabled]="first" type="button" class="btn btn-primary btn-sm"
                aria-label="Up">
                <span class="fa fa-arrow-up" aria-hidden="true"></span>
              </button>
              <button (click)="moveDownLabel(label)" [disabled]="last" type="button" class="btn btn-primary btn-sm"
                aria-label="Down">
                <span class="fa fa-arrow-down" aria-hidden="true"></span>
              </button>
              <button [routerLink]="['label', label.id, 'edit']" type="button" class="btn btn-primary btn-sm"
                aria-label="Edit">
                <span class="fa fa-edit" aria-hidden="true"></span>
              </button>
              <button (click)="deleteLabel(label)" type="button" class="btn btn-secondary btn-sm" aria-label="Delete">
                <span class="fa fa-trash" aria-hidden="true"></span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </mdb-tab>
    <mdb-tab heading="Questions" [customClass]="'order-3'" class="questionsContainer">
      <a [routerLink]="['question','new']" type="button" class="btn btn-primary">New Question</a>
      <p class="alert alert-info" *ngIf="!questionSet.questions.length">There are no questions.</p>
      <table class="table table-striped" *ngIf="questionSet.questions.length">
        <thead class="primary-color text-white">
          <tr>
            <th *ngFor="let name of ['', 'Question', 'Reversed', 'Flagged', 'Scale', 'Actions']">{{name}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let question of questionSet.questions; let index = index;let first=first; let last=last;">
            <td class="col-xs-1">{{index+1}}.
              <!--<td>{{question.id}}</td>-->
            <td class="col-xs-5">{{question.prompt}}</td>
            <td>
              <span *ngIf="question.is_reversed">Yes</span>
              <span *ngIf="!question.is_reversed">No</span>
            </td>
            <td>
              <span *ngIf="question.hasFlagCondition">Yes</span>
              <span *ngIf="!question.hasFlagCondition">No</span>
            </td>
            <td class="col-xs-2">{{question?.assessment_scale?.name}}</td>
            <td class="col-xs-4">
              <button (click)="moveUpQuestion(question)" [disabled]="first" type="button" class="btn btn-primary btn-sm"
                aria-label="Up">
                <span class="fa fa-arrow-up" aria-hidden="true"></span>
              </button>
              <button (click)="moveDownQuestion(question)" [disabled]="last" type="button"
                class="btn btn-primary btn-sm" aria-label="Down">
                <span class="fa fa-arrow-down" aria-hidden="true"></span>
              </button>
              <button [routerLink]="['question',question.id,'edit']" type="button" class="btn btn-primary btn-sm"
                aria-label="Edit">
                <span class="fa fa-edit" aria-hidden="true"></span>
              </button>
              <button (click)="deleteQuestion(question)" type="button" class="btn btn-secondary btn-sm"
                aria-label="Delete">
                <span class="fa fa-trash" aria-hidden="true"></span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </mdb-tab>
    <mdb-tab heading="Advanced" [customClass]="'order-4'">
      <div class="row">
        <div class="form-group col">
          <input id="condition-display" type="checkbox" [checked]="hasConditions(questionSet)"
            (click)="toggleCondition(questionSet)" />
          <label for="condition-display">Conditionally Display?</label>
        </div>
      </div>
      <div class="row">
        <condition-edit *ngIf="hasConditions(questionSet)" class="col p-2" [condition]="Condition"
          [assessment]="Assessment"></condition-edit>
      </div>
      <div class="row">
        <input type="button" (click)="save()" class="btn btn-primary" value="Save" />
      </div>
    </mdb-tab>
  </mdb-tabset>
</div>


// WEBPACK FOOTER //
// ./src/app/admin/question-set-edit/question-set-edit.component.html